// ng imports
import { Component, OnInit, isDevMode } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router, Params } from '@angular/router';

// sn imports
import { AuthService, SessionService } from '../../services';
//import { environment } from '../../../environments/environment';

@Component({
  selector: 'sn-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  //authType: string = '';
  login: string = 'Login';
  title: string = "SalesNOW Customer Portal";
  isSubmitting = false;
  authForm: FormGroup;
  username: string = '';
  password: string = '';
  access_code: string = '';
  isDevMode: boolean;
  login_msg: string = '';
  access_code_required: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private sessionService: SessionService,
    private fb: FormBuilder
  ) {
    this.isDevMode = isDevMode();
    if (this.isDevMode) {
      this.username = '';
      this.password = '';
      this.access_code = '';
    }
    
    this.authForm = this.fb.group({
      'UserName': [this.username, Validators.required],
      'Password': [this.password, Validators.required],
      'AccessCode': [this.access_code],
      'ApiKey': '30da5507-ba5a-480c-ae53-7dfcfe673e4b'
    });
  }

  ngOnInit() {
    this.authService.purgeAuth();
    this.access_code_required = this.sessionService.getQueryVariable("brand").length > 0;
  }

  submitForm() {
    this.login_msg = '';
    this.isSubmitting = true;
    const credentials = this.authForm.value;
    console.log("submitform: ", credentials);
    this.authService.login(credentials).subscribe(
      data => {
        let home_page = this.authService.getAuth().home_page;
        if (home_page && home_page.length > 0) {
          this.router.navigateByUrl(home_page);
        } else {
          let test_page = 'oomph/dashboard';
          this.router.navigateByUrl(test_page);
        }
      },
      err => {
        console.log("login failed");
        this.isSubmitting = false;
        this.login_msg = "Login Failed, unable to verify username and password.";
      }
    )
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/login/login.component.ts